var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"marco-video"},[_c('div',{staticClass:"contenedor-video"},[_c('iframe',{staticClass:"video",attrs:{"src":_vm.url,"allow":"gyroscope; clipboard-write; encrypted-media; picture-in-picture;","allowfullscreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }